import React, { useEffect, useState, useRef } from "react";
import { useStateMachine } from "little-state-machine";
import PropTypes from "prop-types";
import Question from "./components/Question";
import Result from "./components/Result";
import { addNewApp, resetAppState } from "./utils/updateActions";

const App = ({ appId, showResults, theme }) => {
  const { actions } = useStateMachine({ addNewApp, resetAppState });
  const [shouldShowResults, setShouldShowResults] = useState(false);

  const [resetTimes, setResetTimes] = useState(0);

  const appContainerRef = useRef(null);

  useEffect(() => {
    actions.addNewApp(appId);
  }, [actions, appId]);

  const scrollToTop = () => {
    const offset = 80;
    const element = appContainerRef.current;

    const bodyRect = document.body.getBoundingClientRect().top;

    const elementRect = element.getBoundingClientRect().top;

    const elementPosition = elementRect - bodyRect;

    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });

  }

  const resetApp = () => {
    actions.resetAppState(appId);
    setShouldShowResults(false);
    setResetTimes(resetTimes + 1);

    resetKairion();

    scrollToTop();
  }

  const handleShowResults = (bool) => {
    setShouldShowResults(bool);

    resetKairion();
  }

  const onResultRenderComplete = () => {
    scrollToTop();
  }

  // Needed for results with Products
  const resetKairion = () => {
    if (window.kias) {
      window.kias.restartForAjax([
        {
          cmd: 'setPageSlots',
          slots: {}
        },
      ]);
    }
  }

  return (
    <div className="align-center app-content" ref={appContainerRef}>

      {shouldShowResults ? 
      (
        // Results
        <>
          <Result onRenderComplete={onResultRenderComplete} appId={appId} showResults={showResults} />
          <sw-button class="mt-4" onClick={resetApp}>
            {window.Drupal.t('Restart Test')}
            <sw-icon slot="end" name="refresh" class="ml-4"></sw-icon>
          </sw-button>
        </>
      ):
        // Questions
      (
        <Question theme={theme} key={resetTimes} setShouldShowResults={handleShowResults} appId={appId} />
      )
      }
    </div>
  );
};

App.propTypes = {
  appId: PropTypes.string.isRequired, 
};

export default App;
